// extracted by mini-css-extract-plugin
module.exports = {"card":"ShelterEntry_card__2GMFF","textPart":"ShelterEntry_textPart__1mVn8","iconPart":"ShelterEntry_iconPart__3hsaI","photoPart":"ShelterEntry_photoPart__2xH-M"};